import { Routes } from '@angular/router';
import { applicationSubmitGuard } from '@pkp/core';

export const DESKTOP_ABOUT_BENEFITS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/benefits-page/benefits-page.component').then(
        c => c.DesktopBenefitsPageComponent,
      ),
  },
  {
    path: 'benefits-order',
    canActivate: [applicationSubmitGuard],
    loadComponent: () =>
      import('./pages/benefits-order/benefits-order.component').then(
        c => c.DesktopAboutBenefitsOrderComponent,
      ),
  },
];
